// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2GKrm","checkboxCol":"Table_checkboxCol__12-PX","emailCol":"Table_emailCol__3EtMG","actionCol":"Table_actionCol__2G_Fl"};